import React, { useState } from 'react'

import { Box, Typography, Divider, makeStyles, IconButton } from '@material-ui/core'
import { Skeleton } from '@material-ui/lab'

import { AccessTime, ArrowForward, List, Phone, WhatsApp } from '@material-ui/icons'
import PhotoLibraryOutlinedIcon from '@material-ui/icons/PhotoLibraryOutlined'

import { useLiterals } from '~/components/Literals'
import track, { cliqueWhats, log } from '~/track'
import { formatDistance, formatPhoneNumber, getWhatsAppUrl } from '~/utils'

import { StoreDialogImages } from './StoreDialogImages'
import RouteIcon from './RouteIcon'
import StorePeriod from './StorePeriod'

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    display: 'flex',
  },
  content: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    cursor: 'pointer',
    paddingRight: 16,
  },
  item: {
    display: 'flex',
    alignItems: 'center',
    gap: 4,
  },
  badge: {
    width: 8,
    height: 8,
    borderRadius: 9999,
    '&.open': { backgroundColor: '#A6CD30' },
    '&.close': { backgroundColor: '#f44336' },
  },
  iconBottonRoot: {
    padding: 6,
    background: '#EEEBEB',
    marginRight: 8,
    color: '#444444',

    '&:hover': {
      backgroundColor: '#EEEBEB',
    },
  },
  labels: {
    fontSize: 14,
    whiteSpace: 'nowrap',
  },
}))

function CustomDivider() {
  return <Divider style={{ margin: '6px -25px' }} />
}

function MobileGmbStoreDetails({
  store,
  period,
  images,
  isLoading,
  isMobileStoreInformationsFullHeight,
  mapRouteCommunProps,
  config,
  handleSeeMoreProduct,
  currentProduct,
  handleOpenPeriod,
  position,
}) {
  const classes = useStyles()
  const { getLiteral } = useLiterals()
  const phoneNumber = formatPhoneNumber(store?.phoneNumber)

  const [isOpenImages, setIsOpenImages] = useState(false)

  const handleOpenImages = () => {
    setIsOpenImages(true)
    track('cliqueFotosLoja', { category: 'loja', name: store?.name })
  }

  const handleCall = () => {
    track('cliqueVerTelefone', { category: 'menu', name: store?.storeName })
    track('cliqueLigar', { name: store?.storeName, category: 'loja' })
    log({ event: 'call' }, config, store, currentProduct, position?.user)
    window.open(`tel:${phoneNumber}`, '_blank')
  }

  const handleWhatsapp = () => {
    cliqueWhats(currentProduct)
    const linkWhatAppUrl = store?.whatsapp
      ? getWhatsAppUrl(
          store?.whatsapp,
          store?.name,
          currentProduct?.name ||
            Object.values(store.stats)
              .map((i) => i.name)
              .join(),
          config?.brandName,
          !!config?.showContextViewEstablishment,
          getLiteral,
          config?.textToWhatsapp,
        )
      : ''
    window.open(linkWhatAppUrl, '_blank')
  }

  if (isLoading) return <Skeleton animation="wave" variant="rect" width="40%" style={{ marginTop: 16 }} />

  const showPeriod = !!period
  const showMoreProducts = !config.showContextViewEstablishment && isMobileStoreInformationsFullHeight
  const showCellPhone = !!store?.phoneNumber && store?.phoneNumber.trim().length > 0
  const showWhatsapp = !!store?.whatsapp
  const showImage = images.length > 0 && isMobileStoreInformationsFullHeight

  return (
    <>
      <Box
        className={classes.root}
        style={{
          marginTop: 16,
          flexDirection: 'column',
          gap: 4,
          alignItems: 'unset',
        }}
      >
        {showPeriod && (
          <>
            <Box className={classes.content} onClick={handleOpenPeriod}>
              <Box className={classes.item}>
                <IconButton classes={{ root: classes.iconBottonRoot }}>
                  <AccessTime />
                </IconButton>
                <StorePeriod period={period} />
              </Box>
              <ArrowForward style={{ color: '#C4C4C4' }} />
            </Box>
            <CustomDivider />
          </>
        )}

        {/* rotas */}
        <>
          <Box className={classes.content} {...mapRouteCommunProps}>
            <Box className={classes.item}>
              <IconButton classes={{ root: classes.iconBottonRoot }}>
                <RouteIcon />
              </IconButton>
              <Typography className={classes.labels}>
                <span style={{ fontSize: 16, fontWeight: 'bold' }}>{formatDistance(store?.distance || 0)} &bull;</span>
                {' ' + getLiteral('2810')}
              </Typography>
            </Box>
            <ArrowForward style={{ color: '#C4C4C4' }} />
          </Box>
          <CustomDivider />
        </>

        {/* Ligar */}
        {showCellPhone && (
          <>
            <Box className={classes.content} onClick={handleCall} data-cy="call">
              <Box className={classes.item}>
                <IconButton classes={{ root: classes.iconBottonRoot }}>
                  <Phone />
                </IconButton>
                <Typography className={classes.labels}>{getLiteral('1514')}</Typography>
              </Box>
              <ArrowForward style={{ color: '#C4C4C4' }} />
            </Box>
            <CustomDivider />
          </>
        )}

        {/* Whatsapp */}
        {showWhatsapp && (
          <>
            <Box className={classes.content} onClick={handleWhatsapp} data-cy="call">
              <Box className={classes.item}>
                <IconButton
                  classes={{ root: classes.iconBottonRoot }}
                  style={{ background: '#34AF23', color: '#FFFFFF' }}
                >
                  <WhatsApp />
                </IconButton>
                <Typography className={classes.labels}>{getLiteral('2473')}</Typography>
              </Box>
              <ArrowForward style={{ color: '#C4C4C4' }} />
            </Box>
            <CustomDivider />
          </>
        )}

        {/* ver mais produtos */}
        {showMoreProducts && (
          <>
            <Box className={classes.content} onClick={handleSeeMoreProduct}>
              <Box className={classes.item}>
                <IconButton classes={{ root: classes.iconBottonRoot }}>
                  <List />
                </IconButton>
                <Typography className={classes.labels}>{getLiteral('2561')}</Typography>
              </Box>
              <ArrowForward style={{ color: '#C4C4C4' }} />
            </Box>
            <CustomDivider />
          </>
        )}

        {/* ver images */}
        {showImage && (
          <>
            <Box className={classes.content} onClick={handleOpenImages}>
              <Box className={classes.item}>
                <IconButton classes={{ root: classes.iconBottonRoot }}>
                  <PhotoLibraryOutlinedIcon />
                </IconButton>
                <Typography className={classes.labels}>{getLiteral('2560')}</Typography>
              </Box>
              <ArrowForward style={{ color: '#C4C4C4' }} />
            </Box>
            <CustomDivider />
          </>
        )}
      </Box>

      {showImage && (
        <StoreDialogImages store={store} images={images} isOpen={isOpenImages} setIsOpen={setIsOpenImages} />
      )}
    </>
  )
}

export default MobileGmbStoreDetails
